<template>
    <div v-if="items" :id="`list-grow-${prependIcon}`">
        <v-container grid-list-form :style="fontSize ? 'font-size: ' + fontSize + 'px' : ''" :class="showMore ? 'expand' : 'close'">
            <v-layout
                row
                v-for="(item, index) in mainItems"
                :key="`main-${index}-${prependIcon}`"
                class="list-item my-0 py-0"
                :class="{ 'list-hover': perms_allow && !$bp.smallScreen, close: index > 1 && !showMore, clickable: perms_allow }"
                @mouseup.left="perms_allow ? $emit('invoke-method', item) : ''"
            >
                <v-flex shrink class="list-icon">
                    <v-icon
                        :color="iconColor ? iconColor : 'indigo'"
                        v-if="prependIcon && index == 0"
                        :class="prependPosition == 'top' ? 'mb-auto' : 'my-auto'"
                        >{{ prependIcon }}</v-icon
                    >
                </v-flex>
                <v-flex
                    class="list-slot"
                    :class="{ 'border-bottom-divider-1': extraItems.length > 0 || index < mainItems.length - 1 }"
                    :style="!(appendIcon || item.notify == '1') ? 'margin-right: 12px;' : ''"
                >
                    <slot :item="item"></slot>
                </v-flex>
                <v-flex
                    shrink
                    v-if="appendIcon || item.notify == '1'"
                    class="list-icon"
                    :class="{ 'border-bottom-divider-1': extraItems.length > 0 || index < mainItems.length - 1 }"
                    :style="appendIcon || item.notify == '1' ? 'margin-right: 12px;' : ''"
                >
                    <v-icon v-if="item.notify == '1'" :color="iconColor ? iconColor : 'indigo'">notifications_active</v-icon>
                    <v-icon v-else-if="appendIcon" :color="iconColor ? iconColor : 'indigo'">{{ appendIcon }}</v-icon>
                </v-flex>
            </v-layout>
            <v-layout row wrap class="list-transition">
                <v-flex pa-0 xs12 align-self-start class="list-height-wrapper">
                    <v-layout
                        v-for="(item, index) in extraItems"
                        :key="`extra-${index}-${prependIcon}`"
                        class="list-item mx-0 my-0 py-0"
                        :class="{ 'list-hover': perms_allow && !$bp.smallScreen, close: !showMore, clickable: perms_allow }"
                        @mouseup.left="perms_allow ? $emit('invoke-method', item) : ''"
                        row
                    >
                        <v-flex shrink class="list-icon"></v-flex>
                        <v-flex class="list-slot border-bottom-divider-1" style="margin-right: 12px">
                            <slot :item="item"></slot>
                        </v-flex>
                        <v-flex shrink v-if="appendIcon || item.notify == '1'" class="list-icon">
                            <v-icon v-if="item.notify == '1'" :color="iconColor ? iconColor : 'indigo'">notifications_active</v-icon>
                            <v-icon v-else-if="appendIcon" :color="iconColor ? iconColor : 'indigo'">{{ appendIcon }}</v-icon>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <bc-tooltip :disabled="showMore">
                <template slot="activator">
                    <v-layout
                        v-if="items && items.length > 2"
                        class="list-trigger clickable my-0"
                        :class="{ 'list-hover': perms_allow && !$bp.smallScreen, close: showMore }"
                        @mouseup.left="triggerExpand()"
                        row
                    >
                        <v-flex xs12 py-1 px-0><v-icon>expand_more</v-icon></v-flex>
                    </v-layout>
                </template>
                {{ `Show ${items.length - 2} more` }}
            </bc-tooltip>
        </v-container>
    </div>
    <div v-else :class="{ clickable: perms_allow }" @mouseup.left="perms_allow ? $emit('invoke-method') : ''">
        <v-container grid-list-form :style="fontSize ? 'font-size: ' + fontSize + 'px' : ''">
            <v-layout row class="my-0 py-2 list-item" :class="{ 'list-hover': perms_allow && !$bp.smallScreen }">
                <v-flex xs2 class="list-icon">
                    <v-icon :class="prependPosition == 'top' ? 'mb-auto' : 'my-auto'" :color="iconColor ? iconColor : 'indigo'" v-if="prependIcon">{{
                        prependIcon
                    }}</v-icon>
                </v-flex>
                <v-flex :class="appendIcon ? 'xs8' : 'xs10'" class="list-slot">
                    <slot></slot>
                </v-flex>
                <v-flex :xs2="appendIcon" v-if="appendIcon">
                    <v-icon :color="iconColor ? iconColor : 'indigo'">{{ appendIcon }}</v-icon>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
export default {
    props: ["items", "prependIcon", "prependPosition", "appendIcon", "perm", "iconColor", "fontSize"],
    data() {
        return {
            showMore: false,
        };
    },
    computed: {
        mainItems() {
            return this.items ? this.items.slice(0, 2) : [];
        },
        extraItems() {
            return this.items ? this.items.slice(2, this.items.length) : [];
        },
        perms_allow() {
            let allow = true;
            if (this.perm != null) {
                if (typeof this.perm == "string") {
                    allow = this.hasPerm(this.perm);
                } else if (typeof this.perm == "boolean") {
                    allow = this.perm;
                }
            }
            return allow;
        },
    },
    watch: {
        items() {
            this.$nextTick(() => {
                if (this.showMore) {
                    this.calcHeight();
                }
            });
        },
    },
    methods: {
        triggerExpand() {
            this.showMore = !this.showMore;
            this.calcHeight(true);
        },
        calcHeight(reset = false) {
            var growDiv = document.querySelector(`#list-grow-${this.prependIcon} .list-transition`);
            if (growDiv.clientHeight && reset) {
                growDiv.style.height = 0;
            } else {
                var wrapper = document.querySelector(`#list-grow-${this.prependIcon} .list-transition .list-height-wrapper`);
                growDiv.style.height = wrapper.clientHeight + "px";
            }
        },
    },
};
</script>
